import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IniciativaDetalle } from 'src/app/interfaces/interfaces';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-administracion',
  templateUrl: './administracion.component.html',
  styleUrls: ['./administracion.component.scss']
})
export class AdministracionComponent implements OnInit {
  emailUser: string;
  rolesUsuario: number[];
  opcionSeleccionada: number;
  iniciativaSeleccionada: IniciativaDetalle;
  @ViewChild('tabIniciativas', { static: true })
  tabInciativa: ElementRef;
  @ViewChild('tablaIniciativasComponent')
  tablaIniciativaComponent: ElementRef;
  idRolSeleccionado:number;
  isLoading:boolean=false;

  constructor(private authService: AuthService) {
    this.authService.user.subscribe(user => {this.emailUser = user});
    //this.rolesUsuario = this.authService.obtenerRoles();
    this.opcionSeleccionada = 2;
  }

  isInRole(rol: number): boolean {
    return this.authService.isInRole(rol);
  }

  ngOnInit() {
    //Nos subscribimos al método para el rol seleccionado
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
    });
    // Subir a tope de pagina
    this.scrollInicio();
  }


  cambiarIniciativa(iniciativa: IniciativaDetalle) {
    this.iniciativaSeleccionada = iniciativa;
  }

  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
         // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
